import React, { useState, useEffect } from "react";
import Button from "./Button";
import { FaRegFilePdf, FaEye, FaRegTrashAlt } from "react-icons/fa";
import { DateTime } from "luxon";
import { useStateContext } from "../contexts/ContextProvider";
import AlertBox from "./AlertBox";
import ImageCarousel from "./ImageCarousel";
import { apiDeleteBill } from "../services/apiService";

const EditBill = (props) => {
  const { currentBill } = props;
  const { bills, setBills, leases, handleModal, alert, handleAlert } =
    useStateContext();
  const [roomNamesArr, setRoomNamesArr] = useState([]);

  useEffect(() => {
    getRoomNames();
  }, [currentBill]);

  const getRoomNames = () => {
    const idsArray = currentBill.leaseIds;
    let roomNamesArray = [];

    for (const id of idsArray) {
      const item = leases.find((x) => x.id === id);
      if (item) roomNamesArray.push(item.roomName);
    }

    setRoomNamesArr(roomNamesArray);
  };

  const deleteBill = async () => {
    // delete bill route
    const response = await apiDeleteBill(currentBill.id);
    if (response.hasError) {
      console.log(response.error.response.statusText);
      return;
    } else {
      console.log(response.data);
      setBills(
        bills.toSpliced(
          bills.findIndex((x) => x.id === currentBill.id),
          1
        )
      );
      handleModal("editBill");
    }
  };

  return (
    <div className="w-screen h-screen fixed top-0 left-0 right-0 bg-white mt-20 z-10">
      {alert.deleteBill && (
        <AlertBox
          alertType="deleteBill"
          handleAlert={handleAlert}
          alertFunc={() => {
            deleteBill(currentBill);
          }}
        />
      )}
      <div className="flex justify-center px-10 mt-5">
        <div className="w-full md:max-w-[500px] border-gray-300 border-2 rounded-2xl px-10 py-5 capitalize">
          <div className="flex justify-center text-3xl mt-2">
            {currentBill.billType.split("pays")} Bill
          </div>
          <div className="flex justify-center text-xs">
            (
            {DateTime.fromFormat(
              currentBill.serviceStart,
              "yyyy-MM-dd"
            ).toFormat("MM/d/yyyy")}{" "}
            -{" "}
            {DateTime.fromFormat(currentBill.serviceEnd, "yyyy-MM-dd").toFormat(
              "MM/dd/yyyy"
            )}
            )
          </div>
          <div className="flex justify-center mt-3">
            {currentBill.images[0].type === "application/pdf" ? (
              <div className="grid justify-items-center">
                <FaRegFilePdf className="h-20 w-20" />
                <div
                  className="flex justify-center items-center mt-1 gap-x-2 text-blue-500
                 hover:text-blue-700"
                  onClick={() => {
                    window.open(URL.createObjectURL(currentBill.images[0]));
                  }}
                >
                  <FaEye />
                  <div>Preview</div>
                </div>
              </div>
            ) : (
              <ImageCarousel images={currentBill.images} type="bills" />
              // <img
              //   src={
              //     currentBill.images[0] instanceof Blob
              //       ? URL.createObjectURL(currentBill.images[0])
              //       : currentBill.images[0] || noImage
              //     //remove this logic once image handling is setup
              //   }
              //   alt={currentBill.billType}
              //   className="h-40 min-w-40 w-40 object-cover border-gray-300 hover:border-snappily-orange
              // border-2 rounded-lg"
              //   onClick={() => {
              //     window.open(URL.createObjectURL(currentBill.images[0]));
              //   }}
              // />
            )}
          </div>

          <div className="grid grid-cols-2 gap-x-5 mt-5">
            <div>Total Due:</div>
            <div className="place-self-end">
              ${Number(currentBill.totalAmount / 100).toFixed(2)}
            </div>
            <div>Per Room:</div>
            <div className="place-self-end">
              ${(currentBill.splitAmount / 100).toFixed(2)}
            </div>
            <div>Due Date:</div>
            <div className="place-self-end">
              {DateTime.fromFormat(currentBill.dueDate, "yyyy-MM-dd").toFormat(
                "MM/dd/yyyy"
              )}
            </div>
          </div>
          <div>
            <div className="flex justify-center mt-5">Split Between:</div>
            <div
              className={` ${
                roomNamesArr.length === 1
                  ? "flex justify-center"
                  : roomNamesArr.length > 3
                  ? "grid grid-cols-3 justify-items-center"
                  : "grid grid-cols-2 justify-items-center"
              }`}
            >
              {roomNamesArr.map((item, index) => {
                return <div key={index}>{item}</div>;
              })}
            </div>
          </div>
        </div>
      </div>
      <div
        className="flex justify-center items-center text-red-500 hover:text-red-700 mt-3 gap-x-2 cursor-pointer"
        onClick={() => handleAlert("deleteBill")}
      >
        <FaRegTrashAlt /> Delete
      </div>
      <div className="flex justify-center fixed bottom-0 w-full my-10">
        <Button
          background="bg-slate-400"
          text="text-white"
          opacity="bg-opacity-100"
          title="Close"
          height="h-10"
          width="w-24"
          borderColor="border-none"
          borderHover="hover:border-snappily-orange"
          customFunc={() => handleModal("editBill")}
        />
        {/* <Button
          background="bg-snappily-orange"
          text="text-white"
          opacity="bg-opacity-100"
          title={page === pages ? "Submit" : "Next"}
          height="h-10"
          width="w-24"
          borderColor="border-none"
          borderHover="hover:border-snappily-orange"
          customFunc={page === pages ? addBill : nextPage}
        /> */}
      </div>
    </div>
  );
};

export default EditBill;
